module.exports = __webpack_public_path__ + "img/PSE.aa41cea0.svg";